import PropTypes from 'prop-types'

import GreyDot from 'components/ui/GreyDot/GreyDot'

const CustomizedGreyDot = ({ cx, cy, payload, lastDate }) => {
  const { date } = payload

  if (lastDate === date) {
    return <GreyDot cx={cx} cy={cy} />
  }

  return null
}

CustomizedGreyDot.propTypes = {
  payload: PropTypes.shape({
    date: PropTypes.string
  }),
  cx: PropTypes.number,
  cy: PropTypes.number,
  lastDate: PropTypes.string
}

CustomizedGreyDot.defaultProps = {
  payload: {},
  cx: 0,
  cy: 0,
  lastDate: ''
}

export default CustomizedGreyDot
